export const ProgressBar = ({ percent }: { percent: number }) => {
  return (
    <div className="h-2 w-full bg-neutral-4 rounded-full">
      <div className="h-2 bg-platform-500 rounded-full" style={{ width: `${percent}%` }}></div>
    </div>
  );
};
